import * as React from 'react';
import ImageSourceDialog from './image-source-dialog';
import { UADetector } from '../util/UAUtil';

interface Props {
    /** `accept` attribute for the native (non-Android) file input */
    accept?: string
    /** allow selecting multiple files on the native (non-Android) input */
    multiple?: boolean
    /**
     * Called with the picked files.
     * On Android (camera/gallery dialog) this is always a single file;
     * on iOS/desktop it may contain multiple files when `multiple` is set.
     */
    onFilesSelected: (files: File[]) => void
}

interface State {
    dialogOpen: boolean
}

/**
 * File picker that keeps the platform-native <input type="file"> (and its default label)
 * everywhere, but on Android intercepts the tap to open the camera/gallery bottom-sheet
 * (ImageSourceDialog) instead of the OS file picker.
 * Mirrors the Android-only gating already used for avatar uploads (see UADetector.isAndroid()):
 * Android's native file input does not reliably offer a camera/gallery choice, whereas iOS
 * shows its own native sheet, so the custom dialog is Android-only.
 */
export default class ImageSourceInput extends React.Component<Props, State> {
    public state: State = { dialogOpen: false }

    public render() {
        const { accept, multiple, onFilesSelected } = this.props
        const isAndroid = UADetector.isAndroid()

        return <>
            <input type="file"
                accept={accept}
                multiple={multiple}
                onClick={(e) => {
                    if (isAndroid) {
                        // Open the camera/gallery dialog instead of the native picker.
                        e.preventDefault()
                        this.setState({ dialogOpen: true })
                    } else {
                        (e.target as HTMLInputElement).value = ''
                    }
                }}
                onChange={(e) => {
                    if (e.target.files && e.target.files.length > 0) {
                        onFilesSelected(Array.from(e.target.files))
                        e.target.value = ''
                    }
                }} />
            <ImageSourceDialog
                open={this.state.dialogOpen}
                onClose={() => this.setState({ dialogOpen: false })}
                onFileSelected={(file) => onFilesSelected([file])}
            />
        </>
    }
}
